var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1579 5.05713L9.02226 12.1942V20.8044L16.1579 27.9415H17.6039V5.06001H16.1579V5.05713ZM20.2728 5.82517L19.9224 7.22262C21.7718 7.96908 23.3561 9.25086 24.4722 10.9037C25.5884 12.5565 26.1855 14.5049 26.187 16.4993C26.1834 18.4921 25.5852 20.4386 24.4689 22.0895C23.3526 23.7403 21.769 25.0205 19.9209 25.7661L20.2699 27.1591C22.4276 26.3319 24.2842 24.8708 25.5954 22.968C26.9066 21.0653 27.611 18.8101 27.6158 16.4993C27.6141 14.1864 26.9115 11.9284 25.6006 10.0228C24.2898 8.11731 22.4322 6.65376 20.2728 5.82517ZM20.9293 11.1801L20.157 12.413C20.7044 12.944 21.1401 13.579 21.4385 14.2807C21.7369 14.9825 21.892 15.7368 21.8947 16.4993C21.8937 17.2623 21.7401 18.0175 21.4429 18.7202C21.1457 19.423 20.7109 20.0592 20.1641 20.5914L20.9351 21.8271C21.6858 21.1572 22.2867 20.3363 22.6985 19.4183C23.1104 18.5002 23.3239 17.5055 23.325 16.4993C23.3219 15.4941 23.107 14.5009 22.6942 13.5844C22.2814 12.6678 21.68 11.8486 20.9293 11.1801ZM4.73145 12.21V20.7916H7.59199V12.21H4.73145Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/Audio Icon.df188a025faed39a0933220475b7a31b.svg";
export { ForwardRef as ReactComponent };